export default "__VITE_ASSET__61994586__"